<template>
  <div class="view">
    <Title title="クイズセット"/>
    <QuizsetMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import QuizsetMain from '@/components/QuizsetMain'

export default {
  components: {
    Title,
    QuizsetMain
  },
  created: function () {
    this.$store.dispatch('quizset/retrieveQuizsets')
  }
}
</script>
